import { CloseIcon } from 'assets/icons/CloseIcon'
import { CheckBox } from 'components/CheckBox/CheckBox'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import { ISelectValue } from 'constants/globalTypes'
import { createPayrollForSingleUser, createPayrolls } from 'features/payrolls/payrollsSlice'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { AppDispatch } from 'store'
import { Button, CursorPointer, Flex, Separator, StyledContainer } from 'styling/GlobalStyles'
import { BodyText, TitleText } from 'styling/Typography'
import { months } from 'utils/helpers'
import useFocusFirstInput from 'utils/useFocusFirstInput'

export const CreatePayrollModal = ({ closeModal, openViewModal, refetch }: { closeModal: any, openViewModal: any, refetch: any }) => {
    const dispatch = useDispatch<AppDispatch>()
    useFocusFirstInput()
    useModalClose(closeModal)
    const [selectedEmployee, setSelectedEmployee] = useState<ISelectValue | null>(null)
    const [state, setState] = useState({
        allUsers: true,
        singleUser: { value: null, label: null, startDay: 0, endDay: 0 },
        users: [],
        month: null,
        year: null
    })
    const handleSave = async () => {
        try {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const resp = await dispatch(!state.allUsers ? createPayrollForSingleUser(state) : createPayrolls(state))
            if (resp.meta.requestStatus === 'fulfilled') {
                toast.success('Payroll(s) created successfully')
                if (state.allUsers) {
                    refetch()
                    closeModal()

                } else {
                    openViewModal()
                    closeModal()
                }

            }
        } catch (error) {
            console.log(error)
        }
    }

    const getYearsFrom2022 = () => {
        const currentYear = new Date().getFullYear();
        const years = [];

        for (let year = 2022; year <= currentYear; year++) {
            years.push({ label: String(year), value: year });
        }

        return years;
    }

    const parseUsers = (data: any) => {
        return data.data.map((item: any) => ({ label: item.firstName + ' ' + item.lastName, value: item.id }))
    }

    const handleDate = (v: ISelectValue, name: string) => {
        setState(prev => ({ ...prev, [name]: v }))
    }

    const addEmployee = () => {
        setState(prev => ({ ...prev, users: [...prev.users, { ...selectedEmployee }] }))
        setSelectedEmployee(null)
    }

    const handleUserRange = (e: React.ChangeEvent<HTMLInputElement>, userId: number) => {
        setState(prev => {
            const copy = structuredClone(prev)
            if (userId === null) {
                copy.singleUser = { ...copy.singleUser, [e.target.name]: parseInt(e.target.value) }
                return copy
            }
            const userIndex = copy.users.findIndex((u: ISelectValue) => u.value === userId)
            if (userIndex !== -1) {
                copy.users[userIndex] = { ...copy.users[userIndex], [e.target.name]: parseInt(e.target.value) }
            }
            return copy
        })
    }

    const removeUser = (userId: number) => {
        setState(prev => {
            const copy = structuredClone(prev)
            copy.users = copy.users.filter((u: ISelectValue) => u.value !== userId)
            return copy
        })
    }

    const isSaveDisabled = () => {
        if (state.allUsers) {
            return !state.month?.label || !state.year?.label || state.users?.some(u => !u.startDay || !u.endDay || u.startDay < 1 || u.endDay < 1 || u.startDay > u.endDay)
        } else {
            return !state.month?.label || !state.year?.label || !state.singleUser?.value || !state.singleUser?.startDay || !state.singleUser?.endDay || state.singleUser?.startDay < 1 || state.singleUser?.endDay < 1 || state.singleUser?.startDay > state.singleUser?.endDay
        }
    }

    const handleSelectSingleEmployee = (v: ISelectValue) => {
        setState(prev => ({ ...prev, singleUser: { ...prev.singleUser, ...v, startDay: 0, endDay: 0 } }))
    }

    return <Modal black>
        <Flex column between center gap='1rem' style={{ maxHeight: '90vh', overflow: 'auto' }} >
            <Flex column gap='1rem' width='100%' >
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold' >Create Payroll</TitleText>
                    <CursorPointer onClick={closeModal} >
                        <CloseIcon />
                    </CursorPointer>
                </Flex>
                <Flex width='100%' between center gap='1rem' >
                    <HonestSelectInput nomarg onChange={handleDate} name='month' defaultValue={state.month} labelText='Month' options={months.map((m, i) => ({ label: m, value: i }))} />
                    <HonestSelectInput nomarg onChange={handleDate} name='year' defaultValue={state.year} labelText='Year' options={getYearsFrom2022()} />
                </Flex>
                {state.allUsers ? <Flex column width='100%' >
                    <Flex width='100%' gap='1rem' column >
                        <Flex width='100%' gap='2rem' alignEnd>
                            <HonestSelectAsyncInput nomarg defaultValue={selectedEmployee?.label} labelText='Employee' link='users' parserFunction={parseUsers} onChange={v => setSelectedEmployee(v)} name='user' />
                            <Button orange disabled={!selectedEmployee?.value || state.users.some(u => u.value == selectedEmployee.value)} onClick={addEmployee} >Add</Button>
                        </Flex>
                        <Separator />
                        {state.users?.map(u => <StyledContainer width='100%' height='auto' key={u.value} >
                            <Flex center width='100%' between >
                                <BodyText style={{ width: '100%' }} >{u.label}</BodyText>
                                <Flex gap='1rem' center justend>
                                    <Flex gap='1rem' >
                                        <Input value={u.startDay} width='5rem' placeholder='1' type='number' onChange={(e) => handleUserRange(e, u.value)} labelText='Start day' name='startDay' nomarg />
                                        <Input value={u.endDay} width='5rem' placeholder='25' max='25' type='number' onChange={(e) => handleUserRange(e, u.value)} labelText='End day' name='endDay' nomarg />
                                    </Flex>
                                    <CloseIcon onClick={() => removeUser(u.value)} />
                                </Flex>
                            </Flex>
                        </StyledContainer>)}
                    </Flex>
                </Flex> : <Flex width='100%' gap='2rem'>
                    <HonestSelectAsyncInput nomarg defaultValue={state?.singleUser?.label} labelText='Employee' link='users' parserFunction={parseUsers} onChange={v => handleSelectSingleEmployee(v)} name='user' />
                    <Flex gap='1rem' >
                        <Input value={state?.singleUser?.startDay} width='5rem' placeholder='1' type='number' onChange={(e) => handleUserRange(e, null)} labelText='Start day' name='startDay' nomarg />
                        <Input value={state?.singleUser?.endDay} width='5rem' placeholder='25' max='25' type='number' onChange={(e) => handleUserRange(e, null)} labelText='End day' name='endDay' nomarg />
                    </Flex>
                </Flex>}
            </Flex>
            <CheckBox state={state.allUsers} onClick={() => setState(prev => ({ ...prev, allUsers: !prev.allUsers }))} square title='Generate for all users' />

            <Button orange disabled={isSaveDisabled()} onClick={handleSave} >Save</Button>
        </Flex>
    </Modal >
}